import axios from 'axios';
import { AccessTokenDetails, TokenType } from '../interfaces/Login';
import { URL_ENDPOINTS } from '../constants';

const URL = URL_ENDPOINTS.BASE_URL + URL_ENDPOINTS.SECURITY;

const SecurityService = {
  authenticate: async (password: string): Promise<TokenType> => {
    const details: AccessTokenDetails = {
      username: 'token_temporal',
      password: password,
      grant_type: 'password',
      scope: 'ESIGNATURE',
    };
    const body = `username=${details.username}&password=${encodeURIComponent(
      details.password
    )}&grant_type=${details.grant_type}&scope=${details.scope}`;
    const response = await axios.post(URL, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Basic ${process.env.REACT_APP_CLIENT_SECRET}`,
      },
    });
    return response.data.data;
  },
};

export default SecurityService;
